module.exports = __webpack_public_path__ + "static/media/add.b80816f1.svg";